var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.038,
    height: 16.5,
    viewBox: "0 0 14.038 16.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M9.431 7.669a4.1 4.1 0 1 0-4.824 0A6.78 6.78 0 0 0 .25 13.994a2.26 2.26 0 0 0 2.256 2.256h9.026a2.26 2.26 0 0 0 2.256-2.256 6.78 6.78 0 0 0-4.357-6.325ZM4.147 4.35a2.872 2.872 0 1 1 2.872 2.872A2.875 2.875 0 0 1 4.147 4.35Zm7.385 10.667H2.506a1.027 1.027 0 0 1-1.026-1.026 5.539 5.539 0 1 1 11.077 0 1.027 1.027 0 0 1-1.025 1.028Z",
    "data-name": "Path 262"
  }))));
};
export default SvgAvatar;